const homeView = document.querySelector("#home-view");
// console.log(homeView);
if (homeView) {
  function runDonut3() {
    let dom = document.getElementById("donut3");
    let myChart = echarts.init(dom, null, {
      renderer: "canvas",
      useDirtyRect: false,
    });
    let app = {};

    let option;

    option = {
      tooltip: {
        trigger: "item",
      },
      legend: {
        top: "5%",
        left: "center",
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "30",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: 438, name: "Pendiente" },
            { value: 735, name: "Liquidado" },
            // { value: 580, name: 'Email' },
            // { value: 484, name: 'Pendiente' },
            // { value: 300, name: 'Video Ads' }
          ],
        },
      ],
    };

    if (option && typeof option === "object") {
      myChart.setOption(option);
    }

    window.addEventListener("resize", myChart.resize);
  }

  function runDonut2() {
    let dom = document.getElementById("donut2");

    if (dom) {
      let myChart = echarts.init(dom, null, {
        renderer: "canvas",
        useDirtyRect: false,
      });
      let app = {};
      // console.log("hola", subPend[0]);
      let option;
      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            // [["IPSM", 1600.1], ["IPSS", 17560.0], ["Osde", 3070.0]]
            data: [
              {
                value: subPend[0] ? subPend[0][1] : 0,
                name: subPend[0] ? subPend[0][0] : "",
              },
              {
                value: subPend[1] ? subPend[1][1] : 0,
                name: subPend[1] ? subPend[1][0] : "",
              },
              {
                value: subPend[2] ? subPend[2][1] : 0,
                name: subPend[2] ? subPend[2][0] : "",
              },
              {
                value: subPend[3] ? subPend[3][1] : 0,
                name: subPend[3] ? subPend[3][0] : "",
              },
              {
                value: subPend[4] ? subPend[4][1] : 0,
                name: subPend[4] ? subPend[4][0] : "",
              },
            ],
          },
        ],
      };
      // console.log(option["series"]);

      if (option && typeof option === "object") {
        myChart.setOption(option);
      }

      window.addEventListener("resize", myChart.resize);
    }
  }

  function runDonut1() {
    let dom = document.getElementById("donut1");
    if (dom) {
      let myChart = echarts.init(dom, null, {
        renderer: "canvas",
        useDirtyRect: false,
      });
      let app = {};

      let option;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          top: "5%",
          left: "center",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: pendiente, name: "Pendiente" },
              { value: cobrado, name: "Pagado" },
              // { value: 580, name: 'Email' },
              // { value: 484, name: 'Pendiente' },
              // { value: 300, name: 'Video Ads' }
            ],
          },
        ],
      };

      if (option && typeof option === "object") {
        myChart.setOption(option);
      }

      window.addEventListener("resize", myChart.resize);
    }
  }
  function barGraph() {
    let dom = document.getElementById("barGraph");
    if (dom) {
      let myChart = echarts.init(dom, null, {
        renderer: "canvas",
        useDirtyRect: false,
      });
      let app = {};

      // console.log(subComp[0][0], subComp[0][1]);

      let option;

      option = {
        dataset: {
          source: [
            // {"IPSS"=>17560.0, "IPSM"=>1600.1, "Osde"=>3070.0}
            ["score", "amount", "product"],
            [
              74.4,
              subComp[0] ? subComp[0][1] : 0,
              subComp[0] ? subComp[0][0] : "",
            ],
            [
              11.71,
              subComp[1] ? subComp[1][1] : 0,
              subComp[1] ? subComp[1][0] : "",
            ],
            [
              6,
              subComp[2] ? subComp[2][1] : 2,
              subComp[2] ? subComp[2][0] : "",
            ],
            [
              3,
              subComp[3] ? subComp[3][1] : 3,
              subComp[3] ? subComp[0][0] : "",
            ],
            [
              1,
              subComp[4] ? subComp[4][1] : 4,
              subComp[4] ? subComp[4][0] : "",
            ],
          ],
        },
        grid: { containLabel: true },
        xAxis: { name: "" },
        yAxis: { type: "category" },
        visualMap: {
          orient: "horizontal",
          left: "center",
          min: 10,
          max: 100,
          text: ["Alto", "Bajo"],
          // Map the score column to color
          dimension: 0,
          inRange: {
            color: ["#65B581", "#FFCE34", "#FD665F"],
          },
        },
        series: [
          {
            type: "bar",
            encode: {
              // Map the "amount" column to X axis.
              x: "amount",
              // Map the "product" column to Y axis
              y: "product",
            },
          },
        ],
      };

      if (option && typeof option === "object") {
        myChart.setOption(option);
      }

      window.addEventListener("resize", myChart.resize);
    }
  }
  runDonut1();
  runDonut2();
  runDonut3();
  barGraph();
}
